// Initiative scores (Business Value, Technical Feasibility, and their sum)
// come from SharePoint as strings and can carry long floating-point tails
// once summed. Round everything to 2 decimal places before display.

export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function formatScore(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? String(round2(n)) : String(value);
}
